import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'db-ai-builder-disabled',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ai-builder-disabled.component.html',
    styleUrls: ['./ai-builder-disabled.component.scss'],
    standalone: false
})
export class AiBuilderDisabledComponent {

  @Output() onEnable: EventEmitter<void> = new EventEmitter<void>();

}
